import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


// cartTotalStyles.checkoutButton = {
//     css: css`

// @media all and (display-mode: standalone) {
// 			min-height: 50px !important;
//             padding: 30px;
// 	}
//             ${({ theme }: { theme: BaseTheme }) =>
//                 breakpointMediaQueries(
//                     theme,
//                     [
//                         css`
//                             position: fixed;
//                             left: 0;
//                             bottom: 0;
//                             width: 100%;
//                             z-index: ${get(theme, "zIndex.stickyFooter")};
//                         `,
//                         css`
//                             width: 100%;
//                             margin-top: 10px;
//                             position: inherit;
//                             left: inherit;
//                             bottom: inherit;
//                         `,
//                     ],
//                     "min",
//                 )}
//         `,
// }
checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
    @media all and (display-mode: standalone) {
			min-height: 50px !important;
            padding: 30px;
            background: ${getColor("common.background")};
        	}
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        background: ${getColor("common.background")({ theme })};
                        justify-content: center;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                    `,
                    css`
                        margin-left: 16px;
                    `,
                    css`
                        margin-left: auto;
                    `,
                    css`
                        margin-left: auto;
                    `,
                    css`
                        margin-left: auto;
                    `,
                ])}
        `,
}